import Localization from '../localization/LocalizationManager'

export enum WorkflowTypeCreatedByEnum {
  DEFAULT = 'Default',
  PROJECT = 'Project',
}

export const getWorkflowTypeCreatedByCaption = (
  type: WorkflowTypeCreatedByEnum,
) => {
  switch (type) {
    case WorkflowTypeCreatedByEnum.DEFAULT:
      return Localization.translator.default
    case WorkflowTypeCreatedByEnum.PROJECT:
      return Localization.translator.project
    default:
      throw new Error(type + ' is unhandled')
  }
}
